import { post } from "@/ulits/http";

// api/app/getAnswerByAiDialogue
// 获取AI对话结果
export function AItext (params) {
  return post('api/app/getAnswerByAiDialogue',params)
}

// api/app/getAiDialogueHistory
// 获取文生文历史对话
export function historyDialogue(params) {
  return post('api/app/getAiDialogueHistory',params)
}

// api/app/guessLikeApp
export function lickApp(params) {
  return post('api/app/guessLikeApp',params)
}

// api/app/getAppDetail
export function appDeteil(params) {
  return post('api/app/getAppDetail',params)
}

// 点赞 api/app/clickLike
export function clickLike (params) {
  return post('api/app/clickLike',params)
}

// 分享 
export function Appshare(params) {
  return post('api/app/share',params)
}